import * as React from "react";
import { FlexContainer } from "./style";

// TODO: IMPORT FROM NECTAR
export const styleConstantsSizes = {
  XXS: "xxs",
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl",
  XXL: "xxl"
};

interface FlexProps {
  children: React.ReactNode;
  flex?: number;
  direction?: "column" | "column-reverse" | "row" | "row-reverse";
  align?: "center" | "flex-end" | "flex-start";
  justify?: "center" | "flex-end" | "flex-start" | "space-between";
  margin?: {
    top?: keyof typeof styleConstantsSizes;
    bottom?: keyof typeof styleConstantsSizes;
    left?: keyof typeof styleConstantsSizes;
    right?: keyof typeof styleConstantsSizes;
  };
  wrap?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const Flex = ({
  flex,
  direction = "row",
  align,
  justify,
  children,
  margin =
  {
    top: null,
    bottom: null,
    left: null,
    right: null
  },
  wrap = false,
  ...rest
}: FlexProps) => {
  return (
    <FlexContainer
      // @ts-ignore
      flex={flex}
      direction={direction}
      align={align}
      justify={justify}
      margin={margin}
      wrap={wrap?.toString()}
      {...rest}
    >
      {children}
    </FlexContainer>
  );
};

// const { XXS, XS, SM, MD, LG, XL } = styleConstantsSizes;

// Flex.propTypes = {
//   children: PropTypes.node.isRequired,
//   flex: PropTypes.number,
//   direction: PropTypes.oneOf([
//     "column",
//     "column-reverse",
//     "row",
//     "row-reverse"
//   ]),
//   align: PropTypes.oneOf(["center", "flex-end", "flex-start"]),
//   justify: PropTypes.oneOf([
//     "center",
//     "flex-end",
//     "flex-start",
//     "space-between"
//   ]),
//   margin: PropTypes.shape({
//     top: PropTypes.oneOf([XXS, XS, SM, MD, LG, XL]),
//     bottom: PropTypes.oneOf([XXS, XS, SM, MD, LG, XL]),
//     left: PropTypes.oneOf([XXS, XS, SM, MD, LG, XL]),
//     right: PropTypes.oneOf([XXS, XS, SM, MD, LG, XL])
//   }),
//   wrap: PropTypes.bool
// };

// Flex.defaultProps = {
//   flex: null,
//   direction: "row",
//   align: null,
//   justify: null,
//   margin: {
//     top: null,
//     bottom: null,
//     left: null,
//     right: null
//   },
//   wrap: false
// };

export default Flex;
